import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoginUserFormGroup } from './auth-user-form-group.interface';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class LoginUserFormModel {
  readonly fieldNames = {
    email: 'email',
    password: 'password',
    interfaceLanguage: 'interfaceLanguage'
  };

  form: FormGroup<LoginUserFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<LoginUserFormGroup>({
      email: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.email],
      }),
      password: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      interfaceLanguage: new FormControl()
    });
  }
}
